const pdfjsLib = require("../assets/pdf/pdf.js");


// pdfjsLib.workerSrc = "../../static/pdf/pdf.worker.js";

var PDFVIEW = function (dom, options){
  this.container = document.querySelector(dom);
  this.thePDF = null;
  this.pages = null;
  this.scale = 1.5;
  this.width = 595;
  this.height = 842;
  this.cache = {};
  this.cacheNum = 1;
  this.totalNum = 1;
  this.currentNum = 1;
  this.loadedCount = 0;
  this.options = options;
  this.eventType = {};
  if(this.container)
    this.init(options);
}

PDFVIEW.prototype = {

  init: function(options){
    var self = this;
    options = options ? options : {};
    options.pdfurl = options.pdfurl ? options.pdfurl : null;
    options.data = options.data ? options.data : null;
    options.scale = options.scale ? options.scale : self.scale;
    options.lazy = options.lazy === true ? true : false;

    self.container.addEventListener('scroll', function () {
      if (self.container) {
        self.pages = self.container.querySelectorAll('.pageContainer');
      }
      var containerH = self.container.offsetHeight,
      height = containerH * (1 / 3);
      var h = containerH;
      if (self.pages) {
        self.pages.forEach(function (obj,index) {
            var top = obj.getBoundingClientRect().top;
            var bottom = obj.getBoundingClientRect().bottom;
            if (top <= height && bottom > height) {
              self.currentNum = index + 1;
            }
            if (top <= h && bottom > h) {
              self.cacheNum = index + 1;
            }
        })
      }
      if (options.lazy) {
        var num = Math.floor(100 / self.totalNum).toFixed(2);
        if (self.cache[self.cacheNum + ""] && !self.cache[self.cacheNum + ""].loaded) {
            var page = self.cache[self.cacheNum + ""].page;
            var container = self.cache[self.cacheNum + ""].container;
            var pageNum = self.cacheNum;
            self.cache[pageNum + ""].loaded = true;
            var scaledViewport = self.cache[pageNum + ""].scaledViewport;

            self.renderCanvas(page, scaledViewport, pageNum, num, container, options)
        }
        if (self.cache[(self.totalNum - 1) + ""] && self.cache[(self.totalNum - 1) + ""].loaded && !self.cache[self.totalNum + ""].loaded) {
            var page = self.cache[self.totalNum + ""].page;
            var container = self.cache[self.totalNum + ""].container;
            var pageNum = self.totalNum;
            self.cache[pageNum + ""].loaded = true;
            var scaledViewport = self.cache[pageNum + ""].scaledViewport;

            self.renderCanvas(page, scaledViewport, pageNum, num, container, options)
            
        }
      }
    })

    var url = '';
    if (options.pdfurl) {
      url = options.pdfurl
    }
    if(url){
      self.renderPdf(options, {
        url: url
      })
    }else if(options.data){
      var data = options.data;
      var rawLength = data.length;
      if (typeof data === "string" && data != "") {
        var array = [];
        for (i = 0; i < rawLength; i++) {
          array.push(data.charCodeAt(i) & 0xff);
        }
        self.renderPdf(options, {
          data: array
        })
      }
    }
  },

  renderPdf:function(options, obj){
    var self = this;
    if (options.cMapUrl) {
        obj.cMapUrl = options.cMapUrl;
    } else {
        // obj.cMapUrl = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.288/cmaps/';
        obj.cMapUrl = '../assets/pdf/cmaps/';
    }
    obj.cMapPacked = true;
    obj.workerSrc = "../assets/pdf/pdf.worker.js";
    
    obj.rangeChunkSize = 65536;

    pdfjsLib.getDocument(obj).then(function (pdf) {
      self.thePDF = pdf;
      self.totalNum = pdf.numPages;
      var promise = Promise.resolve();
      var num = Math.floor(100 / self.totalNum).toFixed(2);
      for (var i = 1; i <= self.totalNum; i++) {
        self.cache[i + ""] = {
            page: null,
            loaded: false,
            container: null,
            scaledViewport: null
        };
        promise = promise.then(function (pageNum) {
          return self.thePDF.getPage(pageNum).then(function (page) {
              self.cache[pageNum + ""].page = page;
              var viewport = page.getViewport(options.scale);
              var scale = (self.docWidth / viewport.width).toFixed(2);
              var scaledViewport = page.getViewport(parseFloat(scale));
              var id = 'canvas' + pageNum;
              var container = document.getElementById(id);
              if(container){
                self.cache[pageNum + ""].container = container;
                self.cache[pageNum + ""].scaledViewport = scaledViewport;
                
                self.pages = self.container.querySelectorAll('.pageContainer');

                if (window.ActiveXObject || "ActiveXObject" in window) {
                  self.pages[0].style.width = viewport.width + 'px'
                  self.pages[0].style.height = viewport.height + 'px'
                  self.pages[0].setAttribute("data-scale",viewport.width / viewport.height)
								} else {
									var h = self.pages[0].offsetWidth / (viewport.viewBox[2] / viewport.viewBox[3]);
									if (h > viewport.height) {
										h = viewport.height
									}
									// self.pages[0].style.minHeight = h + 'px'
                }
                var sum = 0, containerH = self.container.offsetHeight;
                
                if (self.pages && options.lazy) {
                  self.pages.forEach(function (obj,index) {
                    var top = obj.offsetTop;
                    if (top <= containerH) {
                      sum = index + 1;
                      self.cache[sum + ""].loaded = true;
                    }
                  })
                }
                if (pageNum > sum && options.lazy) {
                  return
                }
                return self.renderCanvas(page, scaledViewport, pageNum, num, container, options)
              }
          })
        }.bind(null, i))
      }
    }).catch(function (err) {
      self.loading.hide();
      var time = new Date().getTime();
      self.endTime = time - self.initTime;
      var arr1 = self.eventType["complete"];
      if (arr1 && arr1 instanceof Array) {
          for (var i = 0; i < arr1.length; i++) {
              arr1[i] && arr1[i].call(self, "error", err.message, self.endTime)
          }
      }
    })
  },
  renderCanvas: function(page, viewport, pageNum, num, container, options) {
    var self = this;
    var viewport = page.getViewport(parseFloat(options.scale));
    var scale = (self.docWidth / viewport.width).toFixed(2);
    var context = container.getContext('2d');
    container.width = viewport.width;
    container.height = viewport.height;
    self.width = viewport.width;
    self.height = viewport.height;
    var renderContext = {
      canvasContext: context,
      viewport: viewport
    };
    page.render(renderContext).then(function(){
      self.loadedCount++;
      if (self.loadedCount === self.totalNum) {
        var arr1 = self.eventType["complete"];
        if (arr1 && arr1 instanceof Array) {
          for (var i = 0; i < arr1.length; i++) {
            arr1[i] && arr1[i].call(self, "success", "pdf加载完成", self.endTime)
          }
        }
      }
    });
    
  },
  on: function (type, callback) {
    if (this.eventType[type] && this.eventType[type] instanceof Array) {
        this.eventType[type].push(callback)
    }
    this.eventType[type] = [callback]
  },
}

export default {
  PDFVIEW:PDFVIEW
}